import type {ColumnFragment, ValueFragment} from "app/gql/graphqlSchema";
import {EmptyValue} from "app/employee/controlCard/display/EmptyValue";
import {InvalidValue} from "app/employee/controlCard/display/InvalidValue";
import {DisplayNumber as DisplayNumberShared} from "app/shared/DisplayNumber";

interface Props {
  column: ColumnFragment & {__typename: "ControlCardNumberColumn"};
  value: ValueFragment;
}

export const DisplayNumber = ({column, value}: Props) => {
  if (value.__typename === "ControlCardNumberValue") {
    return <DisplayNumberShared unit={column.unit} value={value.number} />;
  } else if (value.__typename === "ControlCardEmptyValue") {
    return <EmptyValue />;
  } else {
    return <InvalidValue />;
  }
};
